module.exports = __webpack_public_path__ + "img/baoma.37d1f92d.png";